const NotificationsModule = {
  components: {
    Adsense,
  },
  data() {
    return {
      notifications: {
        docs: [],
        nextPage: 1,
        totalDocs: 0,
      },
    };
  },
  computed: {
    ...Vuex.mapState(['user']),
    unread() {
      return this.notifications.docs.filter((n) => n.status === 'unread')
        .length;
    },
  },
  created: function () {
    this.loadMore();
  },
  methods: {
    mark(notification, status) {
      notification.status = status;
      domestiko.notifications(this.unread);
      return this.$dmtk.notifications.mark(notification._id, status);
    },
    toggle(notification) {
      return this.mark(
        notification,
        notification.status === 'read' ? 'unread' : 'read',
      );
    },
    readAll() {
      domestiko.notifications(0);
      this.notifications.docs.map((n) => (n.status = 'read'));
      return this.$dmtk.notifications.markAll();
    },
    trigger(notification) {
      if (notification.status !== 'read') {
        this.mark(notification, 'read');
      }
      switch (notification.origin) {
        case 'application.created':
        case 'application.received':
          this.$router.push(`mensajes/${notification.payload.threads[0]._id}`);
          break;
        case 'job.verified':
          this.$router.push({
            name: 'job.form',
            params: { id: notification.payload._id },
          });
          break;
        case 'job.published':
          window.open(`/empleo/oferta/${notification.payload.slug}/`);
          break;
      }
    },
    loadMore() {
      if (this.loading) return false;
      if (!this.notifications.nextPage) return false;
      this.loading = true;
      this.$dmtk.notifications.get(this.notifications.nextPage).then((data) => {
        data.docs = this.notifications.docs.concat(data.docs);
        this.notifications = data;
        this.loading = false;
      });
    },
  },
  template: `
      <div class="notifications uk-margin-large-bottom">
        <div class="header uk-text-center uk-width-xxlarge uk-margin-medium-top uk-margin-large-bottom">
          <h1 class="uk-text-bold">Mi Cuenta</h1>
          <p>
            Aquí puedes gestionar tus datos, tus ofertas y tus mensajes con otros usuarios
          </p>
          <p v-if="!user.profile">
            ¿Eres un profesional o una empresa? <a href="/usuarios/panel/?signup=true">Completa tu perfil.</a> 
          </p>
          <!--  
          <p v-if="!user.jobs">
            ¿Estás buscando un profesional? <a href="/usuarios/panel/#/empleo/nuevo">Publica una oferta.</a> 
          </p>
          -->
        </div>
        <div class="uk-block">
          <div class="uk-flex uk-margin-bottom">
            <h3 class="uk-width-expand uk-margin-remove">Mis Notificaciones</h3>
            <button
                @click="readAll()"
                v-if="notifications.totalDocs > 0 && unread > 0"
                class="uk-button uk-button-link uk-button-small"
            >Marcar todo como leído
            </button>
          </div>
          <div class="uk-alert uk-alert-primary" v-if="notifications.totalDocs === 0">
            No tienes ninguna notificación
          </div>
          <div class="notifications-list uk-list uk-list-striped">
            <div
                @click="trigger(notification)"
                :class="['notification', '-' +  notification.status]"
                v-for="notification in notifications.docs"
            >
              <span class="indicator uk-float-right" @click.stop="toggle(notification)"></span>
              <span class="message">
          {{ notification.message }}
        </span><br>
              <span :title="notification.createdAt | dateFormat " class="uk-text-small">
          {{ notification.createdAt | relativeTime }}
        </span>
            </div>
          </div>
        </div>
        <div v-scroll-loading="loadMore"></div>
      </div>
	`,
};
